import {
    INIT_CONNECTION,
    GET_PRESCRIPTIONS,
    GET_PRESCRIPTIONS_BY_ID,
    GET_PRESCRIPTION_BY_NUMBER,
    GET_PRESCRIPTION_BY_STATUS,
    PRESCRIPTION_LOADING,
    GET_PRESCRIPTION_HISTORY,
    PRESCRIPTION_ARRIVED,
    GET_ERRORS,
    DISPENSED_NOTIFICTION,
    NEW_MESSAGE,
    GET_DRAFTED,
    GET_PENDINGS,
    GET_APPROVED,
    UPDATE_DATA,
    OPEN_CHAT, INITIAL_LOAD,
    APPROVE_PRESCRIPTION_LOADING,
    GET_APPROVE_PRESCRIPTIONS,
    DISPENSE_PRESCRIPTION_LOADING,
    GET_DISPENSED_PRESCRIPTIONS,
    Draft_prescription_view, MODAL_PRESCRIPTION_VIEW, GET_DURINFO, START_VIDEO_CALL, OPEN_STORE_MODAL, START_COUNSEL_CALL, COUNSELLING_PRESCRIPTION_ARRIVED
} from "./types";
import api from "../api";
import decode from "jwt-decode";
import _ from "lodash";
import store from '../index'


let orgID;
localStorage.orgID
    ? (orgID = localStorage.orgID)
    : (orgID = 1);
let branchName;
localStorage.branch
    ? (branchName = localStorage.branch)
    : (branchName = "Chama");
// let jwtToken = localStorage.jwtToken let branches = ""; if (jwtToken.roles[0]
// === "PHARMACIST") {     jwtToken         .branch         .map(branche => {
//       branches = branches + "branchName=" + branche;             branches =
// branches + "&";         });     branches = branches.substring(0,
// branches.length - 1);     //branch = "branchName="+branchName; } else {
// branches = "branchName=" + branchName; }
export const messageArrive = newMessage => {
    return { type: NEW_MESSAGE, payload: newMessage };
};

export const prescriptionArrived = message => {
    //console.log("================Inside Mqtt action===============")
    return { type: PRESCRIPTION_ARRIVED, payload: message };
};
export const counsellingPrescription = message => dispatch => {
    //console.log("================Inside Mqtt action===============")
    let orgID;
    localStorage.orgID ? (orgID = localStorage.orgID) : (orgID = 1);
    let branchName;
    localStorage.branch
        ? (branchName = localStorage.branch)
        : (branchName = "Chama");
    // dispatch(getPrescriptionByStatus(orgID, branchName, "CounsellingPending"));
    dispatch({ type: COUNSELLING_PRESCRIPTION_ARRIVED, payload: message });
};

export const mqttConnectionInit = () => {
    return { type: INIT_CONNECTION };
};

export const draft_view = (isView, draft, patientId, prescriptionNumber) => dispatch => {
    dispatch({
        type: Draft_prescription_view,
        payload: {
            isDraftView: isView,
            draft,
            patientId,
            prescriptionNumber
        }
    });

};

const getPresc = () => {

    let jwtToken,
        branch = "";

    localStorage.jwtToken
        ? (jwtToken = decode(localStorage.jwtToken))
        : (jwtToken = 1);
    if (jwtToken.roles[0] === "PHARMACIST") {
        jwtToken
            .branch
            .map(branche => {
                branch = branch + "branchName=" + branche;
                branch = branch + "&";
            });
        branch = branch.substring(0, branch.length - 1);
        //branch = "branchName="+branchName;
    } else {
        branch = "branchName=" + localStorage.branch;
    }
    api
        .prescriptions
        .getPrescriptions(orgID, branch)
        .then(prescriptions => {
            store.dispatch({
                type: GET_PRESCRIPTIONS,
                payload: prescriptions
            });

            getApprovedPresc()
        })
        .catch(err =>
            store.dispatch({
                type: GET_PRESCRIPTIONS,
                payload: null
            })
        );
};

export const presc_modal_view = (isView, prescription, patientId, prescriptionNumber) => dispatch => {
    dispatch({
        type: MODAL_PRESCRIPTION_VIEW,
        payload: {
            isView: isView,
            prescription: prescription,
            patientId: patientId,
            prescriptionNumber: prescriptionNumber
        }
    });

};

export const store_modal_view = (toShow) => dispatch => {
    //console.log("==========Store modal=========="+toShow)
    dispatch({
        type: OPEN_STORE_MODAL,
        payload: { toShow }
    })
}

export const getPrescriptions = (orgId) => dispatch => {

    dispatch(setPrescriptionsLoading());
    let jwtToken,
        branch = "";

    localStorage.jwtToken
        ? (jwtToken = decode(localStorage.jwtToken))
        : (jwtToken = 1);
    if (jwtToken.roles[0] === "PHARMACIST") {
        jwtToken
            .branch
            .map(branche => {
                branch = branch + "branchName=" + branche;
                branch = branch + "&";
            });
        branch = branch.substring(0, branch.length - 1);
        api
            .prescriptions
            .getPrescriptionByStatus(orgID, branch, 'Rejected&prescriptionStatus=Pending')
            .then(prescriptions => {


                dispatch({
                    type: GET_PRESCRIPTIONS,
                    payload: prescriptions
                });
            })
            .catch(err =>
                dispatch({
                    type: GET_PRESCRIPTIONS,
                    payload: null
                })
            );
        //branch = "branchName="+branchName;
    } else {
        branch = "branchName=" + localStorage.branch;
        api
            .prescriptions
            .getPrescriptions(orgID, branch)
            .then(prescriptions => {


                dispatch({
                    type: GET_PRESCRIPTIONS,
                    payload: prescriptions
                });
            })
            .catch(err =>
                dispatch({
                    type: GET_PRESCRIPTIONS,
                    payload: null
                })
            );
    }

};

const getApprovedPresc = () => {
    let jwtToken,
        branch = "";

    localStorage.jwtToken
        ? (jwtToken = decode(localStorage.jwtToken))
        : (jwtToken = 1);
    if (jwtToken.roles[0] === "PHARMACIST") {
        jwtToken
            .branch
            .map(branche => {
                branch = branch + "branchName=" + branche;
                branch = branch + "&";
            });
        branch = branch.substring(0, branch.length - 1);
        //branch = "branchName="+branchName;
    } else {
        branch = "branchName=" + localStorage.branch;
    }
    api
        .prescriptions
        .getApprovedPrescriptions(orgID, branch)
        .then(prescriptions => {

            store.dispatch({

                type: GET_APPROVE_PRESCRIPTIONS,
                payload: prescriptions
            });
        })
        .catch(err =>
            store.dispatch({
                type: GET_APPROVE_PRESCRIPTIONS,
                payload: null
            })
        );
};

export const startVideoCall = (prescription) => dispatch => {
    //console.log("============to despence prescription=============="+JSON.stringify(prescription[0]))
    dispatch({
        type: START_VIDEO_CALL,
        payload: {
            prescription_number: prescription[0].rxInfo.prescriptionNumber, no_of_prescs: prescription.length,
            patientName: prescription[0].patientInfo.firstName + " " + prescription[0].patientInfo.lastName,
            branchName: prescription[0].branchName
        }
    });
}

export const startcounselCall = (payload) => dispatch => {

    dispatch({
        type: START_COUNSEL_CALL,
        payload: payload
    });
}

export const getApprovedPrescriptions = () => dispatch => {

    dispatch(setApprovedPrescriptionsLoading());
    let jwtToken,
        branch = "";

    localStorage.jwtToken
        ? (jwtToken = decode(localStorage.jwtToken))
        : (jwtToken = 1);
    if (jwtToken.roles[0] === "PHARMACIST") {
        jwtToken
            .branch
            .map(branche => {
                branch = branch + "branchName=" + branche;
                branch = branch + "&";
            });
        branch = branch.substring(0, branch.length - 1);
        //branch = "branchName="+branchName;
    } else {
        branch = "branchName=" + localStorage.branch;
    }
    //console.log(orgID+"=======Approved Presssc======="+branch)
    api
        .prescriptions
        .getApprovedPrescriptions(orgID, branch)
        .then(prescriptions => {
            dispatch({
                type: GET_APPROVE_PRESCRIPTIONS,
                payload: prescriptions
            });
        })
        .catch(err =>
            dispatch({
                type: GET_APPROVE_PRESCRIPTIONS,
                payload: null
            })
        );
};

export const getDispensedPrescriptions = () => dispatch => {

    dispatch(setDispensedPrescriptionsLoading());
    let jwtToken,
        branch = "";

    localStorage.jwtToken
        ? (jwtToken = decode(localStorage.jwtToken))
        : (jwtToken = 1);
    if (jwtToken.roles[0] === "PHARMACIST") {
        jwtToken
            .branch
            .map(branche => {
                branch = branch + "branchName=" + branche;
                branch = branch + "&";
            });
        branch = branch.substring(0, branch.length - 1);
        //branch = "branchName="+branchName;
    } else {
        branch = "branchName=" + localStorage.branch;
    }
    api
        .prescriptions
        .getDispensedPrescriptions(orgID, branch)
        .then(prescriptions => {
            dispatch({
                type: GET_DISPENSED_PRESCRIPTIONS,
                payload: prescriptions
            });
        })
        .catch(err =>
            dispatch({
                type: GET_DISPENSED_PRESCRIPTIONS,
                payload: null
            })
        );
};

// export const getPrescriptions = (orgId, branchName) => dispatch => {
//     dispatch({type: INITIAL_LOAD, payload: true});
//     dispatch(setDataUpdating());
//     let jwtToken,
//         branch = "";

//     localStorage.jwtToken
//         ? (jwtToken = decode(localStorage.jwtToken))
//         : (jwtToken = 1);
//     if (jwtToken.roles[0] === "PHARMACIST") {
//         jwtToken
//             .branch
//             .map(branche => {
//                 branch = branch + "branchName=" + branche;
//                 branch = branch + "&";
//             });
//         branch = branch.substring(0, branch.length - 1);
//     } else {
//         branch = "branchName=" + localStorage.branch;
//     }
//     api
//         .prescriptions
//         .getPrescriptions(orgID, branch)
//         .then(prescriptions => {
//             //dispatch({type: GET_PRESCRIPTIONS, payload: prescriptions});
//             dispatch({type: GET_DRAFTED, payload: getDrafted(prescriptions)});
//             dispatch({type: GET_PENDINGS, payload: getPending(prescriptions)});
//             dispatch({type: GET_APPROVED, payload: getApproved(prescriptions)})
//             //dispatch({type: INITIAL_LOAD, payload: false});
//         })
//         .catch(err => dispatch({type: GET_PRESCRIPTIONS, payload: null}));
// };

// Array.prototype.mySwapDelete = function arrayMyShiftDelete(index) {
//     var stop = this.length - 1;
//     while (index < stop) {
//         this[index] = this[++index];
//     }

//     this.pop();
// }

// export const updatePrescriptions = (prescription) => dispatch => {
//     dispatch(setDataUpdating());
//     let new_presc_status = prescription.rxInfo.rxStatus;
//     let drafted =  store
//     .getState()
//     .mqtt.draftPrescriptions
//     let pending =  store
//     .getState()
//     .mqtt.pendingPrescriptions
//     let approved =  store
//     .getState()
//     .mqtt.approvedPrescriptions
//     drafted.push(pending);
//     drafted.push(approved);
//     let prescs = drafted
//     let index = prescs.findIndex(presc => prescription.rxInfo.prescriptionNumber === presc.rxInfo.prescriptionNumber)
//     if (index !== -1) {
//         let found_presc = prescs[index];
//         if (new_presc_status === found_presc.rxInfo.rxStatus) {
//             if (new_presc_status === "Draft" || new_presc_status === "Reject") {
//                 let draft_presc = store
//                     .getState()
//                     .mqtt
//                     .draftPrescriptions
//                 let draftIndex = draft_presc.findIndex(presc => presc.rxInfo.prescriptionNumber === found_presc.rxInfo.prescriptionNumber)
//                 if (draftIndex !== -1) {
//                     draft_presc.mySwapDelete(draftIndex);
//                     draft_presc.unshift(prescription);
//                     dispatch({type: GET_DRAFTED, payload: draft_presc});
//                 }
//             }
//             if (new_presc_status === "Pending") {
//             //console.log("=============Inside Pending1=========================");
//                 let pending_presc = store
//                     .getState()
//                     .mqtt
//                     .pendingPrescriptions
//                 let pendingIndex = pending_presc.findIndex(presc => presc.rxInfo.prescriptionNumber === found_presc.rxInfo.prescriptionNumber)
//                 if (pendingIndex !== -1) {
//                     pending_presc.mySwapDelete(pendingIndex);
//                     pending_presc.unshift(prescription);
//                     dispatch({type: GET_PENDINGS, payload: pending_presc});
//                 }
//             }
//             if (new_presc_status === "Approved") {
//                 let approved_presc = store
//                     .getState()
//                     .mqtt
//                     .approvedPrescriptions
//                 let approvedIndex = approved_presc.findIndex(presc => presc.rxInfo.prescriptionNumber === found_presc.rxInfo.prescriptionNumber)
//                 if (approvedIndex !== -1) {
//                     approved_presc.mySwapDelete(approvedIndex);
//                     approved_presc.unshift(prescription);
//                     dispatch({type: GET_APPROVED, payload: approved_presc});
//                 }
//             }
//         } else {
//             let draft_presc = store
//                 .getState()
//                 .mqtt
//                 .draftPrescriptions
//             let pending_presc = store
//                 .getState()
//                 .mqtt
//                 .pendingPrescriptions
//             let approved_presc = store
//                 .getState()
//                 .mqtt
//                 .approvedPrescriptions
//             let draftIndex = draft_presc.findIndex(presc => presc.rxInfo.prescriptionNumber === found_presc.rxInfo.prescriptionNumber)
//             let pendingIndex = pending_presc.findIndex(presc => presc.rxInfo.prescriptionNumber === found_presc.rxInfo.prescriptionNumber)
//             let approvedIndex = approved_presc.findIndex(presc => presc.rxInfo.prescriptionNumber === found_presc.rxInfo.prescriptionNumber)
//             if (new_presc_status === "Draft" || new_presc_status === "Reject") {
//                 if (draftIndex === -1) {
//                     draft_presc.unshift(prescription);
//                     dispatch({type: GET_DRAFTED, payload: draft_presc});

//                 }
//                 if (pendingIndex !== -1) {
//                     pending_presc.mySwapDelete(pendingIndex);
//                     dispatch({type: GET_PENDINGS, payload: pending_presc});
//                 }
//                 if (approvedIndex !== -1) {
//                     approved_presc.mySwapDelete(approvedIndex);
//                     dispatch({type: GET_APPROVED, payload: approved_presc});
//                 }
//             }
//             if (new_presc_status === "Pending") {
//                 if (draftIndex !== -1) {
//                     draft_presc.mySwapDelete(draftIndex);
//                     dispatch({type: GET_DRAFTED, payload: draft_presc});
//                 }
//                 if (pendingIndex === -1) {
//                     pending_presc.unshift(prescription);
//                     dispatch({type: GET_PENDINGS, payload: pending_presc});
//                 }
//                 if (approvedIndex !== -1) {
//                     approved_presc = approved_presc.splice(approvedIndex, 1);
//                     dispatch({type: GET_APPROVED, payload: approved_presc});
//                 }
//             }
//             if (new_presc_status === "Approved") {
//                 if (draftIndex !== -1) {
//                     draft_presc.mySwapDelete(draftIndex);
//                     dispatch({type: GET_DRAFTED, payload: draft_presc});
//                 }
//                 if (pendingIndex !== -1) {
//                     pending_presc.mySwapDelete(pendingIndex);
//                     dispatch({type: GET_PENDINGS, payload: pending_presc});
//                 }
//                 if (approvedIndex === -1) {
//                     approved_presc.unshift(approvedIndex);
//                     dispatch({type: GET_APPROVED, payload: approved_presc});
//                 }
//             }
//         }
//         //prescs.mySwapDelete(index);
//         //prescs.unshift(prescription);
//         //dispatch({type: GET_PRESCRIPTIONS, payload: prescs});
//     } else {
//         if (new_presc_status === "Draft" || new_presc_status === "Reject") {
//             let draft_presc = store
//                 .getState()
//                 .mqtt
//                 .draftPrescriptions
//             draft_presc = draft_presc.unshift(prescription);
//             dispatch({type: GET_DRAFTED, payload: draft_presc});
//         }
//         if (new_presc_status === "Pending") {
//             let pending_presc = store
//                 .getState()
//                 .mqtt
//                 .pendingPrescriptions
//             pending_presc = pending_presc.unshift(prescription);
//             dispatch({type: GET_PENDINGS, payload: pending_presc});

//         }
//         if (new_presc_status === "Approved") {
//             let approved_presc = store
//                 .getState()
//                 .mqtt
//                 .approvedPrescriptions
//             approved_presc = approved_presc.unshift(prescription);
//             dispatch({type: GET_APPROVED, payload: approved_presc});
//         }
//        // prescs.unshift(prescription);
//         //dispatch({type: GET_PRESCRIPTIONS, payload: prescs});

//     }

//     //update presc here

// };


// function getDrafted(prescriptions) {
//     let drafted = [];
//     //console.log("============Inside draft =============" + drafted.length);
//     prescriptions.map((presc) => {
//         if (presc.rxInfo.rxStatus === "Draft" || presc.rxInfo.rxStatus === "Rejected") {
//             drafted.unshift(presc);
//         }
//     });
//     //console.log("============Inside draft =============" + drafted.length);
//     return drafted
// }

// function getPending(prescriptions) {
//     let pending = [];
//     prescriptions.map((presc) => {
//         if (presc.rxInfo.rxStatus === "Pending") {
//             //console.log("============Inside Pending =============" + JSON.stringify(presc));
//             pending.unshift(presc);
//         }
//     });
//     return pending
// }

// function getApproved(prescriptions) {
//     let approved = [];
//     prescriptions.map((presc) => {
//         if (presc.rxInfo.rxStatus === "Approved") {
//             approved.unshift(presc);
//         }
//     });
//     return approved
// }

export const getPrescriptionsById = (orgId, branch_name, patientId, prescriptionStatus) => dispatch => {
    dispatch(setPrescriptionsLoading());
    api
        .prescriptions
        .getPrescriptionsById(orgID, branchName, patientId, prescriptionStatus)
        .then(prescriptions => {
            dispatch({ type: GET_PRESCRIPTIONS_BY_ID, payload: prescriptions });
        })
        .catch(err => dispatch({ type: GET_PRESCRIPTIONS, payload: null }));
};

export const getDurInfo = (prescription) => dispatch => {

    prescription.orgId = orgID
    api.prescriptions.getDurInfo(prescription)
        .then(durInfo => { dispatch({ type: GET_DURINFO, payload: durInfo }); }
        )
        .catch(err => dispatch({ type: GET_DURINFO, payload: null }));


};



export const getPrescriptionByNumber = (orgId, branch, prescriptionNumber, prescriptionStatus) => dispatch => {
    // let jwtToken,
    //     branch = "";

    // localStorage.jwtToken
    //     ? (jwtToken = decode(localStorage.jwtToken))
    //     : (jwtToken = 1);
    // if (jwtToken.roles[0] === "PHARMACIST") {
    //     jwtToken
    //         .branch
    //         .map(branche => {
    //             branch = branch + "branchName=" + branche;
    //             branch = branch + "&";
    //         });
    //     branch = branch.substring(0, branch.length - 1);
    //     //branch = "branchName="+branchName;
    // } else {
    //     branch = "branchName=" + branchName;
    // }
    dispatch(setPrescriptionsLoading());
    api
        .prescriptions
        .getPrescriptionByNumber(orgID, branch, prescriptionNumber, prescriptionStatus)
        .then(prescriptions => {
            prescriptions.forEach(prescription => {
                dispatch({ type: GET_PRESCRIPTION_BY_NUMBER, payload: prescription });
            });
        })
        .catch(err => dispatch({ type: GET_PRESCRIPTION_BY_NUMBER, payload: null }));
};

export const getPrescriptionByStatus = (orgId, branch, prescriptionStatus) => dispatch => {
    //console.log("==========Inside get dispense prescs=====")
    let jwtToken,
        branch = "";

    localStorage.jwtToken
        ? (jwtToken = decode(localStorage.jwtToken))
        : (jwtToken = 1);
    if (jwtToken.roles[0] === "PHARMACIST") {
        jwtToken
            .branch
            .map(branche => {
                branch = branch + "branchName=" + branche;
                branch = branch + "&";
            });
        branch = branch.substring(0, branch.length - 1);
        //branch = "branchName="+branchName;
    } else {
        branch = "branchName=" + branchName;
    }
    dispatch(setPrescriptionsLoading());
    api
        .prescriptions
        .getPrescriptionByStatus(orgID, branch, prescriptionStatus)
        .then(prescription => {
            dispatch({ type: GET_PRESCRIPTION_BY_STATUS, payload: prescription });
        })
        .catch(err => dispatch({ type: GET_PRESCRIPTION_BY_STATUS, payload: null }));
};

export const postPrescriptions = (orgId, prescriptionData, history) => dispatch => {
    //console.log("=================Prescription Data=============================" + JSON.stringify(prescriptionData));
    let branch = prescriptionData.branchName;
    api
        .prescriptions
        .postPrescriptions(orgID, branch, prescriptionData)
        .then(res => getPresc())
        .catch(err => console.log("================Error============" + err));
};
export const editingPrescriptions = (orgId, prescriptionData) => dispatch => {
    api
        .prescriptions
        .postPrescriptions(orgID, branchName, prescriptionData)
        .then(res => console.log())
        .catch(err => dispatch({ type: GET_ERRORS, payload: err.response.data }));
};

export const dispensePrescription = (orgId, prescriptionData, history) => dispatch => {
    if (!_.isEmpty(prescriptionData)) {
        api
            .prescriptions
            .dispensePrescription(orgID, branchName, prescriptionData)
            .then(res => {
                if (res) {
                    const email = prescriptionData[0].pharmacistInfo.name;
                    dispatch({ type: DISPENSED_NOTIFICTION, payload: email });
                    // getPresc();
                    // history.push("/store");
                    // window
                    //     .location
                    //     .reload();
                    //  history.push("/store");
                }
                else {
                    window
                        .location
                        .reload();
                }
            })
            .catch(error => {
                console.log("=====Dispense Error========" + error)
            }
            );
        // .catch(err => dispatch({
        //     type: GET_ERRORS, payload:
        //         err.response
        // }))
    }
    // else {
    //     window
    //         .location
    //         .reload();
    // }
};



export const prescriptionDeleted = () => dispatch => {
    dispatch({ type: PRESCRIPTION_ARRIVED, payload: [] });
};

export const getPrescriptionHistory = (orgId, branchName, patientId) => dispatch => {
    dispatch(setPrescriptionsLoading());
    api
        .prescriptions
        .getPrescriptionHistory(orgID, branchName, patientId)
        .then(prescription => {
            dispatch({ type: GET_PRESCRIPTION_HISTORY, payload: prescription });
        });
};

// Prescriptions loading
export const setPrescriptionsLoading = () => {
    return { type: PRESCRIPTION_LOADING };
};

export const setApprovedPrescriptionsLoading = () => {
    return { type: APPROVE_PRESCRIPTION_LOADING };
};

export const setDispensedPrescriptionsLoading = () => {
    return { type: DISPENSE_PRESCRIPTION_LOADING };
};
export const setDataUpdating = () => {
    return { type: UPDATE_DATA };
};
export const openChatBar = (value) => dispatch => {
    dispatch({ type: OPEN_CHAT, payload: value });
};